var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSummaryDate(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F1F5FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.6 13.6H24.8V12.8C24.8 12.32 24.48 12 24 12C23.52 12 23.2 12.32 23.2 12.8V13.6H16.8V12.8C16.8 12.32 16.48 12 16 12C15.52 12 15.2 12.32 15.2 12.8V13.6H14.4C13.04 13.6 12 14.64 12 16V16.8H28V16C28 14.64 26.96 13.6 25.6 13.6ZM12 25.6C12 26.96 13.04 28 14.4 28H25.6C26.96 28 28 26.96 28 25.6V18.4H12V25.6ZM24 20C24.48 20 24.8 20.32 24.8 20.8C24.8 21.28 24.48 21.6 24 21.6C23.52 21.6 23.2 21.28 23.2 20.8C23.2 20.32 23.52 20 24 20ZM24 23.2C24.48 23.2 24.8 23.52 24.8 24C24.8 24.48 24.48 24.8 24 24.8C23.52 24.8 23.2 24.48 23.2 24C23.2 23.52 23.52 23.2 24 23.2ZM20 20C20.48 20 20.8 20.32 20.8 20.8C20.8 21.28 20.48 21.6 20 21.6C19.52 21.6 19.2 21.28 19.2 20.8C19.2 20.32 19.52 20 20 20ZM20 23.2C20.48 23.2 20.8 23.52 20.8 24C20.8 24.48 20.48 24.8 20 24.8C19.52 24.8 19.2 24.48 19.2 24C19.2 23.52 19.52 23.2 20 23.2ZM16 20C16.48 20 16.8 20.32 16.8 20.8C16.8 21.28 16.48 21.6 16 21.6C15.52 21.6 15.2 21.28 15.2 20.8C15.2 20.32 15.52 20 16 20ZM16 23.2C16.48 23.2 16.8 23.52 16.8 24C16.8 24.48 16.48 24.8 16 24.8C15.52 24.8 15.2 24.48 15.2 24C15.2 23.52 15.52 23.2 16 23.2Z",
    fill: "#2D4993"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummaryDate);
export default __webpack_public_path__ + "static/media/summaryDate.53d398a340fc3fbca587b76ad9ae6ac3.svg";
export { ForwardRef as ReactComponent };